import { useState } from "react";
import { Loader2, Reply, Send } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

export const isShareReply = (m) => (m?.descrizione || "").startsWith("Risposta dal link di condivisione allegati");

export const ShareReplyButton = ({ entry, praticaId, onSent }) => {
  const [open, setOpen] = useState(false);
  const [txt, setTxt] = useState("");
  const [busy, setBusy] = useState(false);
  const mitt = /Mittente:\s*([^—]+)/.exec(entry.descrizione || "")?.[1]?.trim() || "";
  const send = async () => {
    setBusy(true);
    try {
      await api.post(`/studio/pratiche/${praticaId}/diario/${entry.id}/rispondi-condivisione`, { testo: txt.trim() });
      toast.success("Risposta inviata al destinatario");
      setOpen(false); setTxt(""); onSent?.();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid={`diario-share-reply-${entry.id}`}
        className="mt-1.5 inline-flex items-center gap-1 rounded-md border border-amber-500/50 px-2 py-0.5 text-xs font-semibold text-amber-400 hover:bg-amber-500/10 transition-colors">
        <Reply className="h-3.5 w-3.5" /> Rispondi
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg bg-[#121824] border-slate-800 text-slate-100" data-testid="diario-share-reply-dialog">
          <DialogHeader>
            <DialogTitle>Rispondi al destinatario</DialogTitle>
            <DialogDescription className="text-slate-400">La risposta viene inviata via email{mitt ? ` a ${mitt}` : ""} e annotata nel diario della pratica.</DialogDescription>
          </DialogHeader>
          <textarea value={txt} onChange={(e) => setTxt(e.target.value)} rows={6} maxLength={5000} autoFocus placeholder="Scrivi la risposta" data-testid="diario-share-reply-text"
            className="w-full rounded-md border border-slate-700 bg-slate-900/60 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:ring-1 focus:ring-amber-500" />
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => setOpen(false)} disabled={busy} data-testid="diario-share-reply-cancel" className="border-slate-700 text-slate-300">Annulla</Button>
            <Button onClick={send} disabled={busy || !txt.trim()} data-testid="diario-share-reply-send" className="bg-amber-500 hover:bg-amber-600 text-[#0a0d14] font-semibold">
              {busy ? <Loader2 className="h-4 w-4 mr-1 animate-spin" /> : <Send className="h-4 w-4 mr-1" />} Invia
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
